import type {
  CatalogWidgetSpec,
  WidgetCatalog
} from "../../DashboardPage/redux/widgets.types.ts"

type LibraryGroupKey = "kpi" | "chart" | "table" | "list" | "other"

const LIBRARY_GROUP_ORDER: LibraryGroupKey[] = [
  "kpi",
  "chart",
  "table",
  "list",
  "other"
]

const groupKeyForType = (type: string): LibraryGroupKey => {
  if (
    type === "kpi" ||
    type === "chart" ||
    type === "table" ||
    type === "list"
  ) {
    return type
  }
  return "other"
}

interface LibraryGroup {
  key: LibraryGroupKey
  specs: CatalogWidgetSpec[]
}

const indexCatalogBySpecKey = (
  catalog: WidgetCatalog | null
): Map<string, CatalogWidgetSpec> => {
  const map = new Map<string, CatalogWidgetSpec>()
  for (const spec of catalog?.widgets ?? []) map.set(spec.key, spec)
  return map
}

const indexRestrictedBySpecKey = (
  catalog: WidgetCatalog | null
): Map<string, CatalogWidgetSpec> => {
  const map = new Map<string, CatalogWidgetSpec>()
  for (const spec of catalog?.restricted_widgets ?? []) map.set(spec.key, spec)
  return map
}

const matchesSearch = (spec: CatalogWidgetSpec, query: string): boolean =>
  !query || spec.title.toLowerCase().includes(query)

const groupCatalog = (
  catalog: WidgetCatalog | null,
  search = ""
): LibraryGroup[] => {
  const query = search.trim().toLowerCase()
  const buckets = new Map<LibraryGroupKey, CatalogWidgetSpec[]>()

  for (const spec of catalog?.widgets ?? []) {
    if (spec.stub) continue
    if (!matchesSearch(spec, query)) continue
    const key = groupKeyForType(spec.type)
    const list = buckets.get(key) ?? []
    list.push(spec)
    buckets.set(key, list)
  }

  return LIBRARY_GROUP_ORDER.map((key) => ({
    key,
    specs: buckets.get(key) ?? []
  })).filter((group) => group.specs.length > 0)
}

export {
  type LibraryGroupKey,
  type LibraryGroup,
  LIBRARY_GROUP_ORDER,
  groupKeyForType,
  indexCatalogBySpecKey,
  indexRestrictedBySpecKey,
  groupCatalog
}
